export const formatDate = (date) => new Intl.DateTimeFormat('de-DE', { dateStyle: 'medium' }).format(date)
export const isAudio = (media) => media.mimeType.match(/^audio/)
